import { type Clip, ClipType } from '@air/api/types';
import { formatBytes, formatDuration } from '@air/utilities';
import { isPdfRenderedExtension } from '@air/utils-clips';

const TIMED_CLIP_TYPES: ClipType[] = [ClipType.audio, ClipType.video];

export type WorkspaceAgentAssetPreviewCardMeta = Pick<Clip, 'ext' | 'size' | 'type'> & {
  duration: number | null;
  height: number | null;
  width: number | null;
};

/** Mirrors `AssetGalleryCardMetaDetails`: PDFs render at page size, so no W×H for them. */
export const getWorkspaceAgentAssetMetaLabel = ({
  duration,
  ext,
  height,
  size,
  type,
  width,
}: WorkspaceAgentAssetPreviewCardMeta) => {
  const parts: string[] = [];

  if (ext) {
    parts.push(ext.toUpperCase());
  }

  if (!isPdfRenderedExtension(ext) && width && height) {
    parts.push(`${width} × ${height}`);
  }

  parts.push(formatBytes(size));

  if (duration && TIMED_CLIP_TYPES.includes(type)) {
    parts.push(formatDuration(Math.round(duration)));
  }

  return parts.join(' · ');
};
